import React, { useEffect, useState, memo } from 'react';
const setCookie = (name: string, value: string, days: number) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = '; expires=' + date.toUTCString();
  document.cookie = name + '=' + value + expires + '; path=/';
};
const getCookie = (name: string) => {
  if (typeof document === 'undefined') return null;
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};
export const CopiesCounter = memo(function CopiesCounter() {
  const [copiesLeft, setCopiesLeft] = useState(() => {
    if (typeof document !== 'undefined') {
      const storedCount = getCookie('copiesLeft_silencio');
      return storedCount ? parseInt(storedCount) : 15;
    }
    return 15;
  });
  useEffect(() => {
    if (!getCookie('copiesLeft_silencio')) {
      setCookie('copiesLeft_silencio', '15', 1);
    }
    let intervalId: NodeJS.Timeout;
    const timeoutId = setTimeout(() => {
      intervalId = setInterval(() => {
        setCopiesLeft(prevCount => {
          const newCount = prevCount > 2 ? prevCount - 1 : 2;
          setCookie('copiesLeft_silencio', newCount.toString(), 1);
          return newCount;
        });
      }, 8000);
    }, 3000);
    return () => {
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
    };
  }, []);
  return <div className="bg-[#0B1224] border-b border-[#15203B] py-2 flex justify-center" data-id="element-113">
      <div className="bg-[#F6C65B]/10 border border-[#F6C65B]/30 text-[#F6C65B] font-medium px-4 py-1.5 rounded-full text-sm animate-pulse-soft flex items-center gap-2" data-id="element-114">
        <span className="relative flex h-2.5 w-2.5" data-id="element-115">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#F6C65B] opacity-75" data-id="element-116"></span>
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[#F6C65B]" data-id="element-117"></span>
        </span>
        Solo quedan {copiesLeft} copias disponibles
      </div>
    </div>;
});